/** 工信部 ICP 备案官网首页（备案号需链接至此） */
export const MIIT_BEIAN_HOME_URL = 'https://beian.miit.gov.cn/'

/** 全国互联网安全管理服务平台（公安备案号链接） */
export const PSB_BEIAN_HOME_URL = 'https://www.beian.gov.cn/'

/** 主体备案号（广东省） */
export const ICP_SUBJECT_NUMBER =
  process.env.VUE_APP_ICP_SUBJECT_NUMBER || '粤ICP备2026062724号'

/** 网站 ICP 备案号（本域名） */
export const ICP_SITE_NUMBER =
  process.env.VUE_APP_ICP_SITE_NUMBER || '粤ICP备2026062724号-1'

/**
 * 公安备案展示文案，例如：粤公网安备44010602000001号
 * 取得公安备案后，在构建环境设置 VUE_APP_PSB_BEIAN_DISPLAY
 */
export const PSB_BEIAN_DISPLAY = process.env.VUE_APP_PSB_BEIAN_DISPLAY || ''

/**
 * 公安备案 recordcode（仅数字，用于 beian.gov.cn 查询链接）
 * 例如文案为「粤公网安备44010602000001号」时，此处填 44010602000001
 */
export const PSB_BEIAN_RECORDCODE = process.env.VUE_APP_PSB_BEIAN_RECORDCODE || ''

export function buildPsbBeianUrl (recordcode) {
  const code = String(recordcode || '').replace(/\D/g, '')
  if (!code) return PSB_BEIAN_HOME_URL
  return `https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${code}`
}
